module.exports = __webpack_public_path__ + "static/img/t1-5-1.899ed77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-5-1.png
// module id = euG7
// module chunks = 1